/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Link, } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container, Col, Row, Form, Button, Modal, Spinner } from 'react-bootstrap';
import { DokaImageEditor } from 'react-doka';
import Axios from 'axios';

// project imports
import { IMAGE_TYPES } from 'shared/settings/config';
import { getAdminUrl, getAdminHeaders } from 'shared/http';
import { commonMobileNumberFormat, mobileNumberFormat } from 'shared/modifiers';
import { setEditorPlugins, getEditorDefaults, circleCropMask } from 'shared/doka';
import { setUser } from 'shared/settings/auth';
import { changeemail, resendverifyemail, admindetail, adminudpate, changemobile, verifymobile, resendverifymobile } from 'shared/settings/apiconfig';
import store from 'features/store';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';
import Validators from 'shared/validators';

// style imports
import 'doka/doka.css';
import './Profile.scss';

/* initializes doka editor plugins */
setEditorPlugins();

/**
 * this page is used to edit basic user details
 * 
 * @param props
 * 
 * @returns html code for rendering profile page
 * 
**/

class Profile extends Component {

    formEdited;
    location;
    confirmedNavigation;
    customEditorDefaults;
    profileData;

    constructor(props) {
        super(props);

        this.state = {
            // image
            profileImage: {
                modal: false,
                imgSrc: null,
                tempImg: null
            },

            // form
            profileFormControls: {
                firstName: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.maxLength(45)] },
                lastName: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.maxLength(45)] },
                email: { value: '', valid: false, error: '', validators: [] },
                mobile: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.mobile(), Validators.maxLength(15)] },
            },
            profileFormValid: false,

            // change email
            newEmail: { value: '', error: '', validators: [Validators.required(), Validators.email()] },
            emailModal: false,
            unverifiedemail: null,
            emailverified: 0,
            isemailchanged: true,

            //change mobile number
            mobile: {
                newMobile: { value: '', error: '', validators: [Validators.required(), Validators.mobile()] },
                otp: { value: '', error: '', validators: [] },
                valid: false,
                otpType: ""
            },
            isOtpSent: false,
            mobileModal: false,

            // loading
            pageLoading: true,
            profileFormLoading: false,
            emailLoading: false,
            verifyLoading: false,
            mobileLoading: false,

            showNavigateDialog: false,

            //profile status
            profileStatus: { show: false, type: '', message: '' }
        };

        this.location = [];
        this.formEdited = false;
        this.confirmedNavigation = false;
        this.customEditorDefaults = {
            imageCropAspectRatio: 1,
            cropEnableSelectPreset: false,
            imageCropMinSize: { width: 130, height: 130 },
            willRenderCanvas: (shapes, state) => circleCropMask(shapes, state)
        };
        this.profileData = null;
    }

    componentDidMount() {
        this.getProfileData();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.props.history.push({ pathname: '/Home' });
        }
    }

    /* get user profile data */
    getProfileData = async () => {
        await Axios.get(getAdminUrl(`${admindetail}/${this.props.user.id}`), getAdminHeaders())
            .then(response => {
                this.profileData = { ...response.data.data[0] };
                this.setState({
                    profileFormControls: {
                        firstName: { ...this.state.profileFormControls.firstName, value: this.profileData.firstname, valid: true },
                        lastName: { ...this.state.profileFormControls.lastName, value: this.profileData.lastname, valid: true },
                        email: { ...this.state.profileFormControls.email, value: this.profileData.email, valid: true },
                        mobile: { ...this.state.profileFormControls.mobile, value: this.profileData.mobile ? mobileNumberFormat(this.profileData.mobile) : '', valid: true }
                    },
                    profileFormValid: true,
                    profileImage: { ...this.state.profileImage, imgSrc: this.profileData.url },
                    pageLoading: false,
                    unverifiedemail: this.profileData.unverifiedemail,
                    emailverified: this.profileData.emailverified,
                    newEmail: { ...this.state.newEmail, value: this.profileData.unverifiedemail ? this.profileData.unverifiedemail : null },
                    isemailchanged: this.profileData.unverifiedemail ? false : true
                });
            })
            .catch(error => {
                this.setState({
                    pageLoading: false,
                    profileStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
                // toast.error(error.response.data['message']);
            });
    };

    /* event to trigger file input button internally */
    onClickFileInput = () => {
        document.getElementById('img-profile').click();
    };

    onUploadImage = (event) => {
        this.setState({
            profileImage: {
                ...this.state.profileImage,
                tempImg: URL.createObjectURL(event.target.files[0]),
                modal: true
            }
        });

        // reset input to upload same image
        event.target.value = '';
    };

    onCancelImage = () => {
        this.setState({
            profileImage: {
                ...this.state.profileImage,
                modal: false,
                tempImg: null
            }
        });
    };

    onSaveImage = (output) => {
        this.setState({
            profileImage: {
                ...this.state.profileImage,
                imgSrc: URL.createObjectURL(output.dest),
                modal: false
            }
        });

        // used to convert image to base 64
        let render = new FileReader();

        // trigger once image is loaded into FileReader
        render.onloadend = async () => {
            const data = {
                id: this.props.user.id,
                image: render.result.replace('data:', '').replace(/^.+,/, ''),
            };
            await this.saveProfileImage(data);
        };

        render.readAsDataURL(output.dest);
    };

    saveProfileImage = async (data) => {
        await Axios.put(getAdminUrl(adminudpate), JSON.stringify({ data: data }), getAdminHeaders())
            .then(response => {
                store.dispatch({
                    type: 'SET_USER',
                    payload: {
                        profileImage: response.data['data'][0]['url'],
                        id: this.props.user.id
                    }
                });
                // toast.success(response.data['message']);
                setUser(this.props.user.id);
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    profileStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    };

    onEmailChange = (event) => {
        let inputError = '';

        /* check validation */
        for (let validator of this.state.newEmail.validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }

        if (event.target.value === this.state.profileFormControls.email.value)
            inputError = 'Should not use same email';

        this.setState({
            newEmail: {
                ...this.state.newEmail,
                value: event.target.value,
                error: inputError
            }
        });
    };

    showEmailModal = () => {
        this.setState({
            emailModal: true
        });
    };

    hideEmailModal = () => {
        this.setState({ emailModal: false }, () => this.getProfileData());
    };

    hideMobileModal = () => {
        this.setState({
            mobileModal: false,
            isOtpSent: false,
            mobile: {
                ...this.state.mobile,
                newMobile: {
                    ...this.state.mobile.newMobile,
                    value: '',
                    error: '',
                    valid: false
                },
                otp: {
                    ...this.state.mobile.otp,
                    value: '',
                    error: '',
                    valid: false
                },
                valid: false

            },
            profileStatus: { show: false, type: '', message: '' }
        });
    }

    /* request to re-send verify email for new email */
    verifyNewEmail = async () => {
        this.setState({ verifyLoading: true })
        await Axios.get(getAdminUrl(resendverifyemail), getAdminHeaders())
            .then(response => {
                // toast.success(response.data['message']);
                this.setState({
                    emailModal: false,
                    profileStatus: { show: true, type: 'success', message: response.data['message'] }
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            profileStatus: { show: false, type: '', message: '' }
                        });
                    }, 3000)
                });
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    profileStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            })
            .finally(() => {
                this.setState({ verifyLoading: false, emailModal: false }, () => this.getProfileData());
            });
    };

    saveNewEmail = async () => {
        if (this.state.unverifiedemail === this.state.newEmail.value && !this.state.isemailchanged) {
            this.setState({ isemailchanged: true });
        }
        else {
            if (!this.state.newEmail.error && this.state.newEmail.value) {
                const data = {
                    data: {
                        newemail: this.state.newEmail.value
                    }
                };

                this.setState({ emailLoading: true });
                await Axios.put(getAdminUrl(changeemail), JSON.stringify(data), getAdminHeaders())
                    .then(response => {
                        this.setState({
                            emailModal: false,
                            profileStatus: { show: true, type: 'success', message: 'Verification email is sent to the new email address' }
                        },
                            () => {
                                setTimeout(() => {
                                    this.setState({
                                        profileFormControls: {
                                            ...this.state.profileFormControls,
                                            email: {
                                                ...this.state.profileFormControls.email,
                                                value: this.state.newEmail.value
                                            }
                                        },
                                        emailLoading: false,
                                        emailModal: false,
                                        unverifiedemail: this.state.newEmail.value,
                                        emailverified: 0,
                                        profileStatus: { show: false, type: '', message: '' }

                                    }, () => this.getProfileData());
                                    this.profileData['unverifiedemail'] = this.state.newEmail.value;
                                    this.profileData['emailverified'] = 0;
                                }, 3000);
                            });
                        // toast.success('Verification email is sent to the new email address');
                    })
                    .catch(error => {
                        this.setState({
                            emailLoading: false,
                            profileStatus: { show: true, type: 'danger', message: error.response.data['message'] || 'Failed to update email' }
                        });
                        // toast.error(error.response.data['message'] || 'Failed to update email');
                    });
            }
        }
    };

    /* new mobile number changed */
    onMobileChange = (event) => {
        let inputError = '';
        if (event.target.name === 'newMobile') {
            const eventValue = event.target.value ? commonMobileNumberFormat(event.target.value, this.state.mobile.newMobile.value) : '';
            event.target.value = eventValue ? eventValue : event.target.value;
        }
        /* check validation */
        for (let validator of this.state.mobile[event.target.name].validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }

        if (event.target.value === this.state.profileFormControls.mobile.value)
            inputError = 'Should not use same phone number';

        this.setState({
            mobile: {
                ...this.state.mobile,
                [event.target.name]: {
                    ...this.state.mobile[event.target.name],
                    value: event.target.value,
                    error: inputError,
                    valid: Boolean(!inputError)
                }
            }
        }, () => {
            let valid = false;
            if (this.state.isOtpSent)
                valid = this.state.mobile.newMobile.valid && this.state.mobile.otp.value;
            else
                valid = this.state.mobile.newMobile.valid;
            this.setState({
                mobile: {
                    ...this.state.mobile,
                    valid: valid
                }
            });
        });
    };

    /* otp generated when mobile number changed */
    generateOtp = async (type) => {
        let number = this.state.mobile.newMobile.value.replace(/[^a-zA-Z0-9]/g, '')
        const data = {
            data: {
                newmobile: number,
                otpvia: type
            }
        };
        this.setState({ mobileLoading: true, profileStatus: { show: false, type: '', message: '' } });
        await Axios.put(getAdminUrl(changemobile), JSON.stringify(data), getAdminHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({
                        isOtpSent: true,
                        mobileLoading: false,
                        mobile: {
                            ...this.state.mobile,
                            valid: false,
                            otpType: type
                        }
                    });
                }
            })
            .catch(error => {
                this.setState({
                    isOtpSent: false,
                    mobileLoading: false,
                    profileStatus: { show: true, type: 'danger', message: error.response.data['message'] || 'Failed to update mobile' },
                    mobile: {
                        ...this.state.mobile,
                        valid: false
                    }
                });
            });
    }

    /* called to resend otp  */
    resendOtp = async () => {
        this.setState({ profileStatus: { show: false, type: '', message: '' } });

        const data = {
            data: {
                //newmobile: this.state.mobile.newMobile.value,
                otpvia: this.state.mobile.otpType
            }
        };
        //await Axios.get(getSellerUrl(resendverifymobile), getSellerHeaders())
        await Axios.post(getAdminUrl(resendverifymobile), JSON.stringify(data), getAdminHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({
                        mobileLoading: false,
                        profileStatus: { show: true, type: 'success', message: response.data['message'] }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                isOtpSent: true,
                                mobileLoading: false,
                                profileStatus: { show: false, type: '', message: '' }
                            });
                        }, 1000)
                    });
                }
            })
            .catch(error => {
                this.setState({
                    isOtpSent: false,
                    mobileLoading: false,
                    profileStatus: { show: true, type: 'danger', message: error.response.data['message'] || 'Failed to update mobile' }
                });
            });
    }

    /* submit otp to verify mobile number  */
    submitOtp = async () => {
        this.setState({ mobileLoading: true, profileStatus: { show: false, type: '', message: '' } });
        await Axios.get(getAdminUrl(`${verifymobile}/${this.state.mobile.otp.value}`), getAdminHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({
                        profileStatus: { show: true, type: 'success', message: response.data['message'] },
                        mobileLoading: false
                    }, () => {
                        setTimeout(() => {
                            this.hideMobileModal();
                            this.setState({
                                mobileModal: false,
                                profileStatus: { show: false, type: '', message: '' }
                            }, () => this.getProfileData());
                        }, 3000)
                    });
                }
            })
            .catch(error => {
                this.setState({
                    mobileLoading: false,
                    profileStatus: { show: true, type: 'danger', message: error.response.data['message'] || 'Failed to update mobile' }
                });
            });
    }

    /* check validation for input changes */
    omInputValidation = (event) => {
        this.formEdited = true;

        if (event.target.name === 'mobile') {
            const event_value = commonMobileNumberFormat(event.target.value, this.state.profileFormControls.mobile.value);
            event.target.value = event_value ? event_value : event.target.value;
        }
        const validatedForm = Validators.formValidation({ ...this.state.profileFormControls }, event);

        this.setState({
            profileFormControls: validatedForm['formControls'],
            profileFormValid: validatedForm['formValid']
        });
    };

    /* block the navigation when form edited */
    blockNavigation = (nextLocation) => {
        if (this.formEdited && !this.confirmedNavigation) {
            if (!this.state.showNavigateDialog)
                this.setState({ ...this.state, showNavigateDialog: true });
            this.location = nextLocation;
            return false;
        }
        return true;
    };

    /* called when user clicked discard */
    navigateConfirm = () => {
        if (this.state.showNavigateDialog) {
            this.setState({ ...this.state, showNavigateDialog: false });
            this.confirmedNavigation = true;
            this.props.history.push(this.location.pathname);
        }

    };

    saveProfileForm = async () => {
        const data = { };
        this.setState({ profileFormLoading: true });
        Object.entries(this.state.profileFormControls).forEach(([key, value]) => data[key.toLowerCase()] = value['value']);

        delete data['valid'];
        data['id'] = this.props.user.id;
        /* update profile data */
        await Axios.put(getAdminUrl(adminudpate), JSON.stringify({ data: data }), getAdminHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    // toast.success('Successful');
                    this.setState({
                        profileFormLoading: false,
                        profileStatus: { show: true, type: 'success', message: 'Saved' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                profileStatus: { show: false, type: '', message: '' }
                            }, () => {
                                this.getProfileData();
                                setUser(this.props.user.id);
                            });
                        }, 3000)
                    });
                }
            })
            .catch(error => {
                this.setState({
                    profileFormLoading: false,
                    profileStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
                // toast.error(error.response.data['message']);
            });
    };

    render() {

        return (
            <div className="d-flex flex-column" style={{ overflowY: 'overlay' }}>
                <div className="d-flex flex-row align-items-center border-bottom border-outline" style={{ minHeight: '40px' }}>
                    <div className="d-flex flex-row align-items-center justify-content-center border-right border-outline px-2 h-100">
                        <Link to="/home">
                            <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                            <span className="ml-2">Back</span>
                        </Link>
                    </div>
                    <span className="text-secondary mx-2">My Profile</span>
                </div>
                {
                    this.state.pageLoading ?
                        <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" style={{ margin: "50%" }} />
                        </div> :
                        <Container className="profile-container">
                            <Row>
                                <Col md={4} xs={{ span: 12, order: 1 }}>
                                    <div className="d-flex flex-column justify-content-center align-items-center profile-background profile-image">
                                        <div className="d-flex flex-row justify-content-center profile-rounded">
                                            {
                                                this.state.profileImage.imgSrc ?
                                                    <img src={this.state.profileImage.imgSrc} alt="invalid profile" height="135" width="135" /> :
                                                    <img src={`${process.env.PUBLIC_URL}/static/icons/profile/default_2.svg`} alt="default" style={{ marginTop: '26px' }} height="75" width="75" />
                                            }
                                        </div>
                                        <Form.Control id="img-profile" type="file" onChange={this.onUploadImage} accept={IMAGE_TYPES} hidden />
                                        <span className="mt-2 text-secondary" style={{ cursor: 'pointer' }} onClick={this.onClickFileInput}>
                                            {this.state.profileImage.imgSrc ? 'Change Image' : 'Add Image'}
                                        </span>
                                    </div>
                                </Col>
                                <Col md={8} xs={{ span: 12, order: 2 }}>
                                    <div className="profile-form">
                                        <Form>
                                            <div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.profileFormControls.firstName.error ? <small className="error">{this.state.profileFormControls.firstName.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="firstName" name="firstName" placeholder=" " value={this.state.profileFormControls.firstName.value} className={this.state.profileFormControls.firstName.value ? 'form-control-active' : ''} onChange={this.omInputValidation} />
                                                    <label htmlFor="firstName" className="required">First Name </label>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.profileFormControls.lastName.error ? <small className="error">{this.state.profileFormControls.lastName.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="lastName" name="lastName" placeholder=" " value={this.state.profileFormControls.lastName.value} className={this.state.profileFormControls.lastName.value ? 'form-control-active' : ''} onChange={this.omInputValidation} />
                                                    <label htmlFor="lastName" className="required">Last Name </label>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: "-0.25rem" }}>
                                                <Button className="btn-email"
                                                    disabled={this.state.verifyLoading} onClick={this.showEmailModal}>Click here to change Email
                                                </Button>
                                                <div className="float-control" style={{ margin: "-3% 0%" }}>
                                                    <Form.Control type="text" id="email" name="email" placeholder=" " value={this.state.profileFormControls.email.value} className={this.state.profileFormControls.email.value ? 'form-control-active' : ''} onChange={this.omInputValidation} disabled />
                                                    <label htmlFor="email" className="required">Email </label>
                                                </div>
                                            </div>
                                            <div className="mt-2">
                                                <Button className="btn-email"
                                                    disabled={this.state.mobileLoading} onClick={() => { this.setState({ mobileModal: true }) }}>Click here to change Phone Number</Button>
                                                <div className="float-control" style={{ margin: "-2% 0%" }}>
                                                    <div className="text">
                                                        {
                                                            this.state.profileFormControls.mobile.error && this.state.profileFormControls.mobile.error.length ? <small className="error">{this.state.profileFormControls.mobile.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="mobile" name="mobile" placeholder=" " value={this.state.profileFormControls.mobile.value} className={this.state.profileFormControls.mobile.value ? 'form-control-active' : ''} onChange={this.omInputValidation} disabled />
                                                    <label htmlFor="mobile" className="required">Phone Number </label>
                                                </div>
                                            </div>
                                            <div className="mt-4">
                                                <div id="toaster" className={this.state.profileStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                                    {
                                                        this.state.profileStatus.show ?
                                                            <ToasterMessage type={this.state.profileStatus.type} message={this.state.profileStatus.message} className="alert-handle"></ToasterMessage>
                                                            : null
                                                    }
                                                </div>
                                                <div className="d-flex flex-row justify-content-center">
                                                    <Link to='/home'>
                                                        <Button type="button" variant="outline-primary" className="cancel-button mx-1 btn-white" style={{ width: "90px" }}>Cancel</Button>
                                                    </Link>
                                                    <Button type="button" variant="secondary" className="save-button mx-1" style={{ width: "90px" }} disabled={!this.state.profileFormValid || this.state.profileFormLoading || this.state.profileStatus.type === 'success'}
                                                        onClick={this.saveProfileForm}>Save {' '} {this.state.profileFormLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                                </div>
                                            </div>
                                        </Form>
                                        <div className="note px-2 pb-3 text-center">
                                            <small>Important: If you changed your email address,you will be logged out and you must validate your new email address before you can log in</small>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                }

                {/* dialog box for upprofileFormLoading profile image */}
                <Modal show={this.state.profileImage.modal} size="lg" animation={false} onHide={() => this.setState({ ...this.state })}>
                    <Modal.Header>
                        <Button type="button" onClick={this.onCancelImage} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="doka d-flex flex-column align-items-center justify-content-center">
                        <div className="doka-profile-layout" style={{ width: '100%' }}>
                            <DokaImageEditor {...getEditorDefaults({ width: 130, height: 130 })}
                                {...this.customEditorDefaults} src={this.state.profileImage.tempImg}
                                onProcess={this.onSaveImage} />
                        </div>
                    </Modal.Body>
                </Modal>

                {/* modal to change email */}
                <Modal centered show={this.state.emailModal} className="change-email-modal" size="md" animation={false} onHide={() => { this.setState({ ...this.state }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center w-100">
                            <div className="float-control" style={{ width: "90%" }}>
                                <div className="text">
                                    {
                                        this.state.newEmail.error ? <small className="error">{this.state.newEmail.error}</small> : null
                                    }
                                </div>
                                <Form.Control autoFocus type="text" id="new-email" name="newEmail" placeholder=" "
                                    disabled={(this.state.emailLoading || this.state.unverifiedemail === this.state.newEmail.value) && !this.state.isemailchanged} value={this.state.newEmail.value} onChange={this.onEmailChange} />
                                <label htmlFor="newEmail" className="required">New Email</label>
                            </div>
                            <div className="mt-4">
                                <div id="toaster" className={this.state.profileStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                    {
                                        this.state.profileStatus.show ?
                                            <ToasterMessage type={this.state.profileStatus.type} message={this.state.profileStatus.message} className="alert-handle"></ToasterMessage>
                                            : null
                                    }
                                </div>
                                <div className="d-flex flex-column justify-content-center align-items-center flex-sm-row">
                                    <Button variant="outline-dark btn-white mx-2" onClick={() => { this.hideEmailModal(); this.setState({ newEmail: { ...this.state.newEmail, error: '', value: '' } }) }}
                                        disabled={this.state.emailLoading}>Cancel</Button>
                                    <div className="d-flex flex-row justify-content-center align-items-center mt-2 mt-sm-0">
                                        <Button variant="secondary mx-2" onClick={this.saveNewEmail}
                                            disabled={this.state.newEmail.error || this.state.emailLoading}>{this.state.unverifiedemail && !this.state.isemailchanged ? 'Edit' : 'Submit'}</Button>
                                        {
                                            this.state.emailLoading ?
                                                <Spinner animation="border" variant="info" /> :
                                                null
                                        }
                                    </div>
                                    {
                                        this.state.unverifiedemail && !this.state.isemailchanged ?
                                            <div className="d-flex flex-row justify-content-center align-items-center mt-2 mt-sm-0">

                                                <Button variant="secondary mx-2"
                                                    disabled={this.state.verifyLoading} onClick={this.verifyNewEmail}>Resend Verification Link</Button>
                                            </div> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.mobileModal} className="change-mobile-modal" onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header style={{ borderBottom: "none", marginBottom: "-5%" }}>

                        <Button type="button" onClick={this.hideMobileModal} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body>

                        <div className="d-flex flex-column justify-content-center align-items-center w-100">
                            <div className="float-control" style={{ width: "90%" }}>
                                <div className="text">
                                    {
                                        this.state.mobile.newMobile.error ? <small className="error">{this.state.mobile.newMobile.error}</small> : null
                                    }
                                </div>
                                <Form.Control autoFocus type="text" id="newMobile" name="newMobile" placeholder=" "
                                    value={this.state.mobile.newMobile.value} onChange={this.onMobileChange} />
                                <label htmlFor="newMobile" className="required">New Mobile</label>
                            </div>
                            {this.state.isOtpSent &&
                                <div style={{ width: "90%" }}>
                                    <div className="float-control">
                                        <Form.Control autoFocus type="text" id="otp" name="otp" placeholder="Enter OTP"
                                            value={this.state.mobile.otp.value} onChange={this.onMobileChange} />
                                        <label htmlFor="otp" className="required">OTP</label>
                                    </div>
                                    <Button className="text-info btn-email" style={{ textDecoration: "underline" }} onClick={() => this.resendOtp()}>Resend OTP</Button>
                                </div>
                            }
                            <div className="mt-4">
                                <div className="d-flex" style={{ justifyContent: "space-evenly", alignItems: "baseline" }}>
                                    <div id="toaster" className={this.state.profileStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                        {
                                            this.state.profileStatus.show ?
                                                <div>
                                                    <ToasterMessage type={this.state.profileStatus.type} message={this.state.profileStatus.message} className="alert-handle"></ToasterMessage>
                                                </div>
                                                : null
                                        }
                                    </div>
                                </div>
                                <div className="d-flex flex-column justify-content-center align-items-center flex-sm-row">
                                    {!this.state.isOtpSent &&
                                        <Button variant="outline-dark btn-white mx-2 mb-2" disabled={ this.state.isOtpSent ? !this.state.mobile.valid || this.state.mobileLoading : this.state.profileStatus.show || !this.state.mobile.valid || this.state.mobileLoading } onClick={() => { this.state.isOtpSent ? this.submitOtp() : this.generateOtp("call") }}>Call me</Button>
                                    }
                                    <Button variant="secondary mb-2" disabled={ this.state.isOtpSent ? !this.state.mobile.valid || this.state.mobileLoading : this.state.profileStatus.show || !this.state.mobile.valid || this.state.mobileLoading } onClick={() => { this.state.isOtpSent ? this.submitOtp() : this.generateOtp("sms") }}>{this.state.isOtpSent ? 'Verify & Change ' : 'Text me '}</Button>
                                    {
                                        this.state.mobileLoading ?
                                            <Spinner className="ml-1" animation="border" variant="info" /> :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                {/* <Prompt when={this.formEdited} message={this.blockNavigation} />
                {
                    this.state.showNavigateDialog ?
                        <Modal className="confirm-modal" show={this.state.showNavigateDialog} onHide={() => this.setState({ ...this.state, showNavigateDialog: false })}>
                            <Modal.Header style={{ border: "none" }} closeButton ></Modal.Header>
                            <Modal.Body className="confirm-modal-body">
                                Are you sure you want to discard the changes?
                                <Row style={{ marginTop: "5%" }}>
                                    <Col xs={6} md={6}>
                                        <Button className="cancel-button" onClick={() => this.setState({ ...this.state, showNavigateDialog: false })}>No,wait</Button>
                                    </Col>
                                    <Col xs={6} md={6}>
                                        <Button className="save-button" onClick={() => this.navigateConfirm()}>Yes,Discard it</Button>
                                    </Col>
                                </Row>
                            </Modal.Body>
                        </Modal> : null
                } */}
            </div>
        );
    }
}

export default connect(state => state)(Profile);
